import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { authSelector } from '../features/auth/slice';
import axios from 'axios';

export default function useUnreadMessageCount() {
  const [count, setCount] = useState(0);
  const { me } = useSelector(authSelector.selectAuthState);

  const fetch = useCallback(async () => {
    try {
      const res = await axios.get('/api/message/unread-count');
      setCount(res.data.count);
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    if (!me) {
      setCount(0);
      return;
    }
    fetch();
    const interval = setInterval(fetch, 30000);
    return () => clearInterval(interval);
  }, [me, fetch]);

  return { count, refresh: fetch };
}
